import React from "react";
import { size, COLORS } from "../../utils";
import { Grid, Typography, CardMedia, Button } from "@mui/material"
import styles from './Intro.module.css';

export default function Intro() {
    return (
        <Grid item container flexWrap={'nowrap'} alignItems={'center'} justifyContent={'center'}
            width={size({ p: 100 })} height={size({ p: 90, h: true })} columnGap={size({ p: 3 })} className={styles.introWrapper}>
            <Grid item container flexWrap={'nowrap'} direction={'column'} width={size({ p: 30 })}
                height={size({ p: 50, h: true })} justifyContent={'center'}
                rowGap={size({ p: 0.2, h: true })} className={styles.introText}>
                <Grid item>
                    <Typography component={'span'}
                        sx={{
                            fontFamily: 'Space Mono',
                            fontSize: size({ p: 1 }),
                            fontWeight: 400,
                            textAlign: 'left',
                            color: COLORS.C2,
                        }}
                    >
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography component={'span'}
                        sx={{
                            fontFamily: 'Space Mono',
                            fontSize: size({ p: 2.5 }),
                            fontWeight: 700,
                            textAlign: 'left',
                            textTransform: 'uppercase',
                            wordSpacing: size({ p: 0.6, neg: true }),
                            color: COLORS.C2,
                            ml:'3rem'
                        }}
                         className={styles.heading}
                    >
                        #1 Research Assistance
                    </Typography>
                </Grid>

                <Grid item>
                    <Typography component={'span'}
                        sx={{
                            fontFamily: 'Space Mono',
                            fontSize: size({ p: 0.9 }),
                            fontWeight: 200,
                            textAlign: 'left',
                            wordSpacing: size({ p: -0.2 }),
                            color: COLORS.C2,
                            ml:'3rem'
                        }}
                         className={styles.heading}
                    >
                        Accelerate Your Research Journey with Us
                    </Typography>
                </Grid>
                <Grid item>
                    <Button variant="contained" className={styles.cta}
                        onClick={() => {
                            document.getElementById('ra_reach_us').scrollIntoView({
                                behavior: 'smooth', block: 'center'
                            })
                        }}
                        sx={{
                            backgroundColor: `${COLORS.C2}`,
                            fontFamily: 'Archia',
                            fontWeight: 400,
                            fontSize: size({ p: 1 }),
                            color: COLORS.WHITE,
                            textTransform: 'none',
                            ml:'3rem',
                            ':hover': {
                                backgroundColor: `${COLORS.C2}`,
                            },
                            marginTop: size({ p: 3, h: true })
                        }}>{'Reach Us Now'}</Button>
                </Grid>
            </Grid>
            <Grid item className={styles.imageWrapper}>
                <CardMedia
                    component={'img'}
                    image={'/assets/images/research_assistance/research.svg'}
                    sx={{
                        width: size({ p: 40 }),
                        height: size({ p: 40 }),
                        objectFit: 'contain',
                        mr:'2rem'
                    }} />
            </Grid>
        </Grid>
    )
}
